import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vShow as _vShow } from "vue"
import _imports_0 from './assets/loading.png'


const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = {
  key: 0,
  style: {"display":"flex","align-items":"center"}
}
const _hoisted_3 = { class: "switch" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "switch-name" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "switch-name" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "language-name" }
const _hoisted_10 = { class: "search" }
const _hoisted_11 = { class: "search-window search-left" }
const _hoisted_12 = { class: "search-title" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("svg", {
  width: "14",
  height: "14",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "currentColor",
    "fill-rule": "evenodd",
    d: "M10.75 1a.75.75 0 0 0 0 1.5h1.69L8.22 6.72a.75.75 0 0 0 1.06 1.06l4.22-4.22v1.69a.75.75 0 0 0 1.5 0V1h-4.25ZM2.5 4v9a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V8.75a.75.75 0 0 1 1.5 0V13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h4.25a.75.75 0 0 1 0 1.5H3a.5.5 0 0 0-.5.5Z",
    "clip-rule": "evenodd"
  })
], -1)
const _hoisted_14 = { key: 1 }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("svg", {
  width: "14",
  height: "14",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("g", { fill: "none" }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M0 0h24v24H0z" }),
    /*#__PURE__*/_createElementVNode("path", {
      fill: "currentColor",
      d: "M19 2a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-2v2a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h2V4a2 2 0 0 1 2-2h10Zm-4 6H5v12h10V8Zm-5 7a1 1 0 1 1 0 2H8a1 1 0 1 1 0-2h2Zm9-11H9v2h6a2 2 0 0 1 2 2v8h2V4Zm-7 7a1 1 0 0 1 .117 1.993L12 13H8a1 1 0 0 1-.117-1.993L8 11h4Z"
    })
  ])
], -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { class: "search-input-container" }
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "search-window search-right" }
const _hoisted_20 = { class: "selected-title" }
const _hoisted_21 = { class: "search-results" }
const _hoisted_22 = { class: "user-item" }
const _hoisted_23 = { class: "userID" }
const _hoisted_24 = { class: "user-email" }
const _hoisted_25 = ["src", "onClick"]
const _hoisted_26 = { class: "call-buttons" }
const _hoisted_27 = ["disabled"]
const _hoisted_28 = {
  src: _imports_0,
  class: "loading-img"
}
const _hoisted_29 = { id: "debug" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Debug Panel")
], -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", null, "UserID: ", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import { ref, onMounted,onUnmounted, nextTick } from "vue";
import { TUICallKit, TUICallKitServer, STATUS, TUIGlobal } from "@tencentcloud/call-uikit-vue";
import DeviceDetector from "./components/DeviceDetector/index.vue";
import * as GenerateTestUserSig from "../public/debug/GenerateTestUserSig-es.js";
import TIM from "@tencentcloud/chat";
import copy from "copy-to-clipboard";
import videoBlackSVG from "./assets/videoBlack.svg";
import videoWhiteSVG from "./assets/videoWhite.svg";
import audioWhiteSVG from "./assets/audioWhite.svg";
import audioBlackSVG from "./assets/audioBlack.svg";
import searchSVG from "./assets/search.svg";
import cancelSVG from "./assets/cancel.svg";
import languageSVG from "./assets/language.svg";
import { ElMessage, ElLoading } from "element-plus";
import { getUrlParam , isWeixin} from "./utils";
import jweixin from "weixin-js-sdk";
import { useI18n } from "vue-i18n";
import "./App.css";
import * as uni from "./utils/uni.webview.1.5.4.js";

const websocketUrl = "wss://rehabilitation.wss.dph.cn/websocket";
// 本地开发环境
// const websocketUrl = "ws://192.168.1.43:19999/websocket";
// websocket心跳间隔（毫秒）
const WEBSOCKET_HEART_BEAT_INTERVAL = 20000;

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const { t, locale } = useI18n();
const isMobile = !TUIGlobal.isPC;
const SDKAppID = ref<number>(0);
const SecretKey = ref<string>("");
const userID = ref<string>("");
const loginUserID = ref<string>("");
const userList = ref<string[]>([]);
const currentUserID = ref<string>("");
const isLogin = ref<boolean>(false);
const userSig = ref<string>("");
const formImId = ref<string>("");
const isNewTab = ref<boolean>(false);
const isMinimized = ref<boolean>(false);
const finishedRTCDetectStatus = ref<string>("");
const isSkippedRTCDetect = ref<boolean>(false);
const isLoadCalling = ref<boolean>(false);

const typeString = ref<string>("video");
const isCalling = ref<boolean>(false);
const groupID = ref<string>("");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let loadingInstance: any = null;
let ws: any = null;
// 测试环境
//const websocketUrl = "wss://rehabilitation.wss.test.dph.cn/websocket";
// 正式环境
let heartbeatInterval: any = null; //检测服务器端是否还活着
let reconnectTimeOut: any = null; //重连之后多久再次重连
let isOpenSocket = false; //避免重复连接
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let tim: any = null;

onMounted(() => {
    if (isWeixin() || isMobile) {
        loadingInstance = ElLoading.service({ fullscreen: true });
    }
    const sdkAppID = getUrlParam("SDKAppID");
    if (!sdkAppID) SDKAppID.value = 0;
    else {
        SDKAppID.value = parseInt(sdkAppID as string);
        isNewTab.value = true;
    }
    userSig.value = getUrlParam("userSig") || "";
    formImId.value = getUrlParam("formImId") || "";
    loginUserID.value = getUrlParam("userID") || "";
    initWebSocket();
    console.log("loginUserID.value==", loginUserID.value);
    console.log("userSig.value==", userSig.value);
    console.log("SDKAppID.value==", SDKAppID.value);
    if (SDKAppID.value && userSig.value && loginUserID.value) {
        autoLogin();
    }
    TUICallKitServer.setLanguage(locale.value);
    finishedRTCDetectStatus.value =
        localStorage.getItem("callkit-basic-demo-finish-rtc-detect") || "";
});

onUnmounted(() => {
    if (isLogin.value) {
        handleDestroy();
    }
});

async function autoLogin() {
    if (!SDKAppID.value || SDKAppID.value === 0) {
        ElMessage.error(t("input-SDKAppID"));
        return;
    }
    if (!userSig.value) {
        ElMessage.error(t("input-SecretKey"));
        return;
    }
    if (!loginUserID.value) {
        ElMessage.error(t("input-userID"));
        return;
    }
    console.log("tim==", tim);
    if (!isLogin.value) {
        tim = TIM.create({
            SDKAppID: SDKAppID.value,
        });
        await TUICallKitServer.init({
            userID: loginUserID.value,
            userSig: userSig.value,
            SDKAppID: Number(SDKAppID.value),
            tim,
        });
        currentUserID.value = loginUserID.value;
        isLogin.value = true;
        // 通知医生端SDK初始化成功
        sendTuiCallKitInitMessage();
        // if (
        //     finishedRTCDetectStatus.value !== "finished" &&
        //     finishedRTCDetectStatus.value !== "skiped"
        // )
        //     initNetWorkInfo();
    } else {
        // 通知医生端SDK初始化成功
        sendTuiCallKitInitMessage();
    }
}

async function login() {
    if (!SDKAppID.value || SDKAppID.value === 0) {
        ElMessage.error(t("input-SDKAppID"));
        return;
    }
    tim = TIM.create({
        SDKAppID: SDKAppID.value,
    });
    try {
        await TUICallKitServer.init({
            userID: loginUserID.value,
            userSig: userSig.value,
            SDKAppID: Number(SDKAppID.value),
            tim,
        });
        currentUserID.value = loginUserID.value;
        isLogin.value = true;
        if (
            finishedRTCDetectStatus.value !== "finished" &&
            finishedRTCDetectStatus.value !== "skiped"
        )
            initNetWorkInfo();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
        if (error.message)
            ElMessage.error(`${t("login-failed-message")} ${error.message}`);
    }
}

function initWebSocket() {
    ws = new WebSocket(websocketUrl);
    ws.onopen = () => {
        console.log("Websocket  WebSocket连接正常！");
        if (reconnectTimeOut) {
            clearTimeout(reconnectTimeOut);
        }
        if (heartbeatInterval) {
            clearTimeout(heartbeatInterval);
        }
        isOpenSocket = true;
        send({ type: "REGISTER", userId: `${loginUserID.value}-trtc` });
        start();
    };
    ws.onmessage = (event) => {
        console.log("Websocket message received.", event.data);
    };
    ws.onerror = (error) => {
        console.error("Websocket error occurred.", error);
    };
    ws.onclose = () => {
        console.log("Websocket 已经被关闭了");
        isOpenSocket = false;
        reconnect();
    };
}

//重新连接
function reconnect() {
    //停止发送心跳
    clearInterval(heartbeatInterval);
    //如果不是人为关闭的话，进行重连
    if (!isOpenSocket) {
        reconnectTimeOut = setTimeout(() => {
            initWebSocket();
        }, 3000);
    }
}

//开启心跳检测
function start() {
    console.log("开启心跳检测2222222");
    heartbeatInterval = setInterval(() => {
        let data = {
            type: "HEARTBEAT",
            userId: `${loginUserID.value}-trtc`,
        };
        send(data);
    }, WEBSOCKET_HEART_BEAT_INTERVAL);
}

function send(data) {
    if (ws.readyState === WebSocket.OPEN) {
        console.log("send===", data);
        ws.send(JSON.stringify(data));
    } else {
        console.error("Websocket connection not open.");
    }
}

function sendTuiCallKitInitMessage() {
    let data = {
        type: "TEXT",
        toUserId: formImId.value,
        clientTimeStamp: Date.now(),
        messageCode: 3000,
        userId: `${loginUserID.value}-trtc`,
    };
    send(data);
}

function closeWebSocket() {
    if (ws) {
        ws.close();
    }
}

function handleDestroy() {
    TUICallKitServer.destroyed();
    logout();
    closeWebSocket();
    isLogin.value = false;
}

function switchCallType(type: string) {
    if (isCalling.value) return;
    typeString.value = type;
}

async function startCall(typeString: string) {
    if (!isLogin.value) {
        ElMessage.error(t("not-login"));
        return;
    }
    const type = typeString === "audio" ? 1 : 2;
    if (userList.value.length <= 0) {
        ElMessage.error(t("calling-list-is-empty"));
        return;
    }
    const callType = userList.value.length === 1 ? "call" : "groupCall";
    isLoadCalling.value = true;
    try {
        isCalling.value = true;
        if (callType === "call")
            await TUICallKitServer.call({ userID: userList.value[0], type });
        else {
            // you can use existing groups, no need to create a new group every time
            groupID.value = await createGroup();
            await TUICallKitServer.groupCall({
                userIDList: userList.value,
                type,
                groupID: groupID.value,
            });
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
        isCalling.value = false;
        console.error("startCall", error);
        if (error.message) ElMessage.error(error.message);
    }
    isLoadCalling.value = false;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function beforeCalling(type: string, error: any) {
    console.log("basic demo beforeCalling", type, error);
    if (!error) isCalling.value = true;
    else {
        console.error("basic demo beforeCalling", error);
        ElMessage.error(`${error.type}: ${error.message}`);
    }
}

function afterCalling() {
    userList.value = [];
    isCalling.value = false;
    isMinimized.value = false;
    console.log("handleStatusChanged:", jweixin.miniProgram);
    if (isWeixin()) {
        console.log("navigateBack: isWeixin");
        jweixin.miniProgram.navigateBack();
    }else{
        uni.webView.navigateBack();
    }
}

function onMinimized(oldStatus: boolean, newStatus: boolean) {
    console.log("onMinimized: " + oldStatus + " -> " + newStatus);
    if (newStatus === true) {
        isMinimized.value = true;
    } else {
        isMinimized.value = false;
    }
}

function addUser(userIDParam: string) {
    if (!userIDParam) return;
    let index = userList.value.indexOf(userIDParam);
    index < 0 && userList.value.push(userIDParam);
    userID.value = "";
}

function removeUser(userID: string) {
    let index = userList.value.indexOf(userID);
    index > -1 && userList.value.splice(index, 1);
}

async function createGroup() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const memberList: any[] = [];
    userList.value.forEach((user: string) => {
        memberList.push({ userID: user });
    });
    let res = await tim.createGroup({
        type: TIM.TYPES.GRP_PUBLIC,
        name: "group-call",
        memberList,
    });
    return res.data.group.groupID;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function newTab(event: any) {
    event.stopPropagation();
    window.open(
        `/?SDKAppID=${SDKAppID.value}&SecretKey=${SecretKey.value}`,
        "_blank"
    );
}

function copyUserID() {
    const isSuccessCopy = copy(currentUserID.value);
    if (isSuccessCopy) {
        ElMessage.success(t("copied"));
    } else {
        ElMessage.warning(t("copy-failed-message"));
    }
}

function handleClose() {
    showDeviceDetector.value = false;
    isSkippedRTCDetect.value = true;
    ElMessage.warning(t("skip-device-detector"));
    localStorage.setItem("callkit-basic-demo-finish-rtc-detect", "skiped");
}

function handleFinishDetect() {
    showDeviceDetector.value = false;
    finishedRTCDetectStatus.value = "finished";
    localStorage.setItem("callkit-basic-demo-finish-rtc-detect", "finished");
}

const networkDetectInfo = ref();
const showDeviceDetector = ref<boolean>(false);

const initNetWorkInfo = async () => {
    console.log("initNetWorkInfo");
    if (!SDKAppID.value || !SecretKey.value) {
        ElMessage.error(t("please-input-param"));
        return;
    }
    const status = localStorage.getItem("callkit-basic-demo-finish-rtc-detect");
    if (status === "finished") return;
    const uplinkUserId = currentUserID.value + "_uplink_test";
    const downlinkUserId = currentUserID.value + "_downlink_test";
    const roomId = 999999;
    showDeviceDetector.value = true;
};

function switchLanguage() {
    switch (locale.value) {
        case "zh-cn":
            locale.value = "en";
            localStorage.setItem("basic-demo-language", "en");
            TUICallKitServer.setLanguage("en");
            break;
        case "en":
        default:
            locale.value = "zh-cn";
            localStorage.setItem("basic-demo-language", "zh-cn");
            TUICallKitServer.setLanguage("zh-cn");
            break;
    }
}

async function logout() {
    await TUICallKitServer.destroyed();
    tim.logout();
    isLogin.value = false;
}

function handleKickedOut() {
    console.log("The user has been kicked out");
    isLogin.value = false;
}

let TUICallKitStatus: string = STATUS.IDLE;
function handleStatusChanged(args: { oldStatus: string; newStatus: string }) {
    const { oldStatus, newStatus } = args;
    console.log("Call status changes: " + oldStatus + " -> " + newStatus);
    TUICallKitStatus = newStatus;
    if (newStatus === STATUS.IDLE) {

    } else {
        nextTick(() => {
            // 以服务的方式调用的 Loading 需要异步关闭
            if (loadingInstance) {
                loadingInstance.close();
            }
        });
    }
}

async function accept() {
    try {
        if (TUICallKitStatus === STATUS.BE_INVITED) {
            await TUICallKitServer.accept();
            ElMessage.warning("Answered automatically");
        }
    } catch (error: any) {
        alert(`Automatic answering failed, reason: ${error}`);
    }
}

async function reject() {
    try {
        if (TUICallKitStatus === STATUS.BE_INVITED) {
            await TUICallKitServer.reject();
            ElMessage.warning("Automatically rejected");
        }
    } catch (error: any) {
        alert(`Automatic rejection failed due to: ${error}`);
    }
}

async function hangup() {
    try {
        if (
            TUICallKitStatus === STATUS.CALLING_C2C_AUDIO ||
            TUICallKitStatus === STATUS.CALLING_C2C_VIDEO ||
            TUICallKitStatus === STATUS.CALLING_GROUP_AUDIO ||
            TUICallKitStatus === STATUS.CALLING_GROUP_VIDEO
        ) {
            await TUICallKitServer.hangup();
            ElMessage.warning("Automatically hung up");
        }
    } catch (error: any) {
        alert(`Automatic hang-up failed, reason: ${error}`);
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(DeviceDetector, {
      visible: showDeviceDetector.value,
      onClose: handleClose,
      onFinish: handleFinishDetect,
      networkDetectInfo: networkDetectInfo.value
    }, null, 8, ["visible", "networkDetectInfo"]),
    (!isCalling.value && !_unref(isWeixin)())
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              class: _normalizeClass(["switch-btn", typeString.value === 'video' ? 'switch-select' : '']),
              style: _normalizeStyle(
                        isCalling.value ? 'cursor: not-allowed' : 'cursor: pointer'
                    ),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (switchCallType('video')))
            }, [
              _createElementVNode("img", {
                src: 
                            typeString.value === 'video'
                                ? _unref(videoWhiteSVG)
                                : _unref(videoBlackSVG)
                        ,
                class: "icon"
              }, null, 8, _hoisted_4),
              _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(t)("video-call")), 1)
            ], 6),
            _createElementVNode("div", {
              class: _normalizeClass(["switch-btn", typeString.value === 'audio' ? 'switch-select' : '']),
              style: _normalizeStyle(
                        isCalling.value ? 'cursor: not-allowed' : 'cursor: pointer'
                    ),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (switchCallType('audio')))
            }, [
              _createElementVNode("img", {
                src: 
                            typeString.value === 'audio'
                                ? _unref(audioWhiteSVG)
                                : _unref(audioBlackSVG)
                        ,
                class: "icon"
              }, null, 8, _hoisted_6),
              _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(t)("voice-call")), 1)
            ], 6)
          ])
        ]))
      : _createCommentVNode("", true),
    (!_unref(isWeixin)() && !isMobile)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(isMobile ? 'switch-language-H5' : 'switch-language'),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (switchLanguage()))
        }, [
          _createElementVNode("img", {
            src: _unref(languageSVG),
            class: "icon"
          }, null, 8, _hoisted_8),
          _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(locale) == "en" ? "简体中文" : "English"), 1)
        ], 2))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(isMobile ? 'call-kit-container-H5' : 'call-kit-container')
    }, [
      _withDirectives(_createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createTextVNode(_toDisplayString(typeString.value === "video"
                                ? _unref(t)("video-call")
                                : _unref(t)("voice-call")) + " ", 1),
            (isLogin.value)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: "user-id",
                  onClick: copyUserID
                }, [
                  _createTextVNode(" userID: " + _toDisplayString(currentUserID.value) + " ", 1),
                  (!isNewTab.value)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: _cache[3] || (_cache[3] = (event) => newTab(event))
                      }, [
                        _createTextVNode(_toDisplayString(_unref(t)("login-other")) + " UserID ", 1),
                        _hoisted_13
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_14, _hoisted_16)),
                  _createElementVNode("button", {
                    onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (logout()), ["stop"]))
                  }, _toDisplayString(_unref(t)("logout")), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("img", {
              src: _unref(searchSVG),
              class: "icon-search"
            }, null, 8, _hoisted_18),
            _withDirectives(_createElementVNode("input", {
              class: "search-input",
              type: "text",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((userID).value = $event))
            }, null, 512), [
              [_vModelText, userID.value]
            ])
          ]),
          _createElementVNode("div", {
            class: "add-btn",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (addUser(userID.value)))
          }, _toDisplayString(_unref(t)("add-to-calling-list")), 1)
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, _toDisplayString(_unref(t)("calling-list")), 1),
          _createElementVNode("div", _hoisted_21, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userList.value, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "result-item",
                key: item
              }, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, _toDisplayString(item), 1),
                  _createElementVNode("div", _hoisted_24, _toDisplayString(item), 1)
                ]),
                _createElementVNode("img", {
                  src: _unref(cancelSVG),
                  class: "checkbox cancel",
                  onClick: ($event: any) => (removeUser(item))
                }, null, 8, _hoisted_25)
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_26, [
            _withDirectives(_createElementVNode("div", {
              class: "rtc-detector-starter",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (initNetWorkInfo()))
            }, _toDisplayString(_unref(t)("start-to-detector")), 513), [
              [_vShow, isLogin.value]
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(
                                !isLoadCalling.value ? 'call-btn' : 'call-btn-gray'
                            ),
              onClick: _cache[8] || (_cache[8] = ($event: any) => (startCall(typeString.value))),
              disabled: isLoadCalling.value
            }, [
              _withDirectives(_createElementVNode("img", _hoisted_28, null, 512), [
                [_vShow, isLoadCalling.value]
              ]),
              _createTextVNode(" " + _toDisplayString(_unref(t)("call")), 1)
            ], 10, _hoisted_27)
          ])
        ])
      ], 512), [
        [_vShow, !_unref(isWeixin)() && !isMobile && (!isCalling.value || isMinimized.value)]
      ]),
      _createVNode(_unref(TUICallKit), {
        beforeCalling: beforeCalling,
        afterCalling: afterCalling,
        onMinimized: onMinimized,
        allowedMinimized: true,
        allowedFullScreen: true,
        kickedOut: handleKickedOut,
        statusChanged: handleStatusChanged
      })
    ], 2),
    _withDirectives(_createElementVNode("div", _hoisted_29, [
      _hoisted_30,
      _hoisted_31,
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((loginUserID).value = $event)),
        placeholder: "UserID"
      }, null, 512), [
        [_vModelText, loginUserID.value]
      ]),
      _hoisted_32,
      _createElementVNode("button", {
        onClick: _cache[10] || (_cache[10] = ($event: any) => (login()))
      }, _toDisplayString(_unref(t)("login")), 1)
    ], 512), [
      [_vShow, !_unref(isWeixin)() && !isMobile && false]
    ])
  ]))
}
}

})